import { CMGTheme } from './cmg';
import { Theme } from './theme';

export const DefaultTheme = CMGTheme as Theme;
